import { blockFourColumnTextIconScript } from '../../../includes/blocks/block-four-column-text-icon/scripts';

export function windowWidth() {
    const windowBreakPoints = 1440;
    let disableFunctionForMobile = false;
    let myWidth;
    setWindowSize();
    window.addEventListener('resize', setWindowSize);
    function setWindowSize() {
        if (typeof (window.innerWidth) == 'number') {
          myWidth = window.innerWidth;
        } else {
          if (document.documentElement && document.documentElement.clientWidth ) {
            myWidth = document.documentElement.clientWidth;
          } else {
            if (document.body && document.body.clientWidth) {
              myWidth = document.body.clientWidth;
            }
          }
        }
        if(document.querySelector('.blog__category')){
            if(myWidth <= windowBreakPoints){
                disableFunctionForMobile = true;
                let blogSearch = document.querySelector('.blog__search');
                blogSearch.classList.add('active');
            }
        }
        if(document.querySelector('.blockFourColumnTextIcon')){
           if(myWidth <= 767){
             console.log('myWidth',myWidth)
             console.log('windowBreakPoints',windowBreakPoints)
            document.addEventListener( 'DOMContentLoaded', function () {
              blockFourColumnTextIconScript();
            });
           }
        }
    } 
}